import React from "react";
import { Image, StyleSheet, View, Linking } from "react-native";
import { DataTable } from "react-native-paper";
import { TableValueCellComponent } from "./Types";
import { isImage } from "../../utils/mediaUtils";

const linkTextStyle = { textDecorationLine: "underline" as const };
type Attachment = {
  uri: string;
  name: string;
  mimeType: string;
};

export const TableFileCell: TableValueCellComponent = ({
  field,
  value,
  t,
  linkColor,
}) => {
  if (!value) {
    return (
      <DataTable.Cell style={{ flex: field.width || 1 }}>-</DataTable.Cell>
    );
  }

  if (typeof value === "string") {
    return (
      <DataTable.Cell
        style={{ flex: field.width || 1 }}
        textStyle={[linkTextStyle, { color: linkColor }]}
        onPress={() => Linking.openURL(value)}
      >
        {t("Download")}
      </DataTable.Cell>
    );
  }

  if (Array.isArray(value) && value.length > 0) {
    const attachments = value as Attachment[];

    const firstImage =
      attachments.find((attachment) => isImage(attachment.mimeType)) || null;
    const imageUri = firstImage?.uri;

    if (imageUri) {
      return (
        <DataTable.Cell style={{ flex: field.width || 1 }}>
          <View style={styles.imageWrapper}>
            <Image source={{ uri: imageUri }} style={styles.imagePreview} />
          </View>
        </DataTable.Cell>
      );
    }

    const firstFile = attachments[0];
    const fileUrl = firstFile.uri;
    const fileName = firstFile.name || "File";

    return (
      <DataTable.Cell
        style={{ flex: field.width || 1 }}
        textStyle={[linkTextStyle, { color: linkColor }]}
        onPress={() => Linking.openURL(fileUrl)}
      >
        {fileName}
      </DataTable.Cell>
    );
  }

  return <DataTable.Cell style={{ flex: field.width || 1 }}>-</DataTable.Cell>;
};

const styles = StyleSheet.create({
  imageWrapper: {
    width: 44,
    height: 44,
    borderRadius: 8,
    overflow: "hidden",
    backgroundColor: "#F3F4F6",
  },
  imagePreview: {
    width: "100%",
    height: "100%",
  },
});
